'use strict';

export default {
  methods: {
    getDocumentos (group = false) {
      this.$service.get('documentos')
      .then(response => {
        if (response) {
          if (group) {
            let documentos = response;
            let items = {};
            documentos.map(item => {
              let key = `${item.entidad_nombre} (${item.clasificacion.replace('_', ' por ')})`;
              if (!items[key]) {
                items[key] = [];
              }
              items[key].push(item);
            });
            this.docs = response;
            this.documentos = items;
          } else {
            this.documentos = response;
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/mixins/documentos.js